import { ToroAccountSimple } from './../../../api/models/toro-account-simple.model';

import { accountActionTypes } from './account.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { accountAdapter, AccountState } from './account.entity';
import { EntityState } from '@ngrx/entity';
import { authActionTypes } from './../../../auth/store/auth.actions';

// export const accountAdapter: EntityAdapter<ToroLocation> = createEntityAdapter<ToroLocation>();

export const initialState = accountAdapter.getInitialState({
  ids: [],
  loaded: false,
  currentAccount: null,
  total: 0
});

export const accountReducerObj = createReducer(
  initialState,

  on(accountActionTypes.LoadAccountsSuccess, (state, action) => {
    return accountAdapter.addAll(
      action.accounts,
      {
        ...state,
        // accounts: action.accounts,
        loaded: action.accounts.length > 0,
        total: action.accounts.length
      }
    );
  }),

  on(authActionTypes.LogOut, (state, action) => {
    return accountAdapter.removeAll({
      ...state,
      loaded: false,
      total: 0,
      currentAccount: null
    });
  }),
  on(accountActionTypes.SelectAccount, (state, action) => {
    return {
      ...state,
      currentAccount: action.currentAccount
    }

  }),

  on(accountActionTypes.unsetAccount, (state, action) => {
    return {
      ...state,
      currentAccount: null
    }

  }),
  //   on(accountActionTypes.addRepresentative, (state, action) => {
  //     return adapter.addOne(action.representative,  state);
  //   }),

  on(accountActionTypes.DeleteAccount, (state, action) => {
    return accountAdapter.removeOne(action.accountId, state);
  }),

  //   on(accountActionTypes.updateAccountAddress, (state, action) => {
  //     return adapter.updateOne(action.organization, state);
  //   })
);

export function accountReducer(state: AccountState, action: Action) {
  return accountReducerObj(state, action);
}

export const { selectAll, selectIds } = accountAdapter.getSelectors();
